import React, { useState, useEffect } from "react";
import { Modal, Icon, Select, TimePicker, Button, Form, Menu, Dropdown, Checkbox, DatePicker, InputNumber } from "antd";
import axios from "axios";
import moment from "moment";
import "moment/locale/pt";

import { useNotification } from "../../../../shared/hooks/useNotification";

moment.locale("pt");

const { Option } = Select;

const ModalCriacaoLoteAulas = ({ visible, disciplinas, dataCalendario, vistaCalendario, onClose, onSalvar, onSalvarRepetir, form }) => {
    const [repetir, setRepetir] = useState(false);
    const [dataLimite, setDataLimite] = useState(null);
    const [totalSemanas, setTotalSemanas] = useState(0);
    const [erroRepetir, setErroRepetir] = useState(false);
    const [aulas, setAulas] = useState([
        {
            key: 1,
            disciplinaId: undefined,
            diaSemana: undefined,
            horaInicio: null,
            horaTermino: null,
            professorId: undefined
        }
    ]);
    const [problemasPorAula, setProblemasPorAula] = useState([]);
    const [professores, setProfessores] = useState([]);
    const [diasSemana, setDiasSemana] = useState([]);
    const [semanas, setSemanas] = useState([]);
    const [semanaSelecionada, setSemanasSelecionada] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);

    const notify = useNotification();

    const handleChangeDataLimite = date => {
        setDataLimite(date);
        setTotalSemanas(0);
    };

    const handleChangeTotalSemanas = value => {
        setTotalSemanas(value);
        setDataLimite(null);
    };

    const adicionarAula = () => {
        const novaAula = {
            key: aulas.length + 1,
            disciplinaId: undefined,
            diaSemana: undefined,
            horaInicio: null,
            horaTermino: null,
            professorId: undefined
        };
        setAulas([...aulas, novaAula]);
    };

    const carregarHoraDisponivel = (aulaKey, disciplinaId, dia) => {
        axios({
            method: "get",
            url: "/api/aulas/apanhar-ultima-hora",
            params: {
                disciplinaId,
                data: dia
            }
        })
            .then(response => {
                const { hr_inicio, hr_termino } = response.data;

                const hrInicio = moment(hr_inicio || response.data, "HH:mm");
                const hrTermino = hr_termino ? moment(hr_termino, "HH:mm") : moment(response.data, "HH:mm").add(1, "hour");

                setAulas(prevAulas =>
                    prevAulas.map(aula =>
                        aula.key === aulaKey
                            ? {
                                  ...aula,
                                  horaInicio: hrInicio,
                                  horaTermino: hrTermino
                              }
                            : aula
                    )
                );
            })
            .catch(() => {});
    };

    const calcularProximaHora = (aulas, aulaKey, horaFim) => {
        const horaFormatada = moment(horaFim, "HH:mm");
        const hrInicio = horaFormatada.add(1, "hour");
        const hrTermino = hrInicio.clone().add(1, "hour");

        return aulas.map(aula => (aula.key === aulaKey ? { ...aula, horaInicio: hrInicio, horaTermino: hrTermino } : aula));
    };

    const atualizarAula = (aulaKey, campo, valor) => {
        let aulasAlteradas = aulas.map(aula => (aula.key === aulaKey ? { ...aula, [campo]: valor } : aula));

        switch (campo) {
            case "disciplinaId":
                {
                    const professoresDisciplina = disciplinas.find(d => d.id === valor)?.professores || [];

                    setProfessores(professoresDisciplina);

                    const aula = aulasAlteradas.find(a => a.key === aulaKey);

                    if (!(aula?.diaSemana && !aulasAlteradas.some(a => a.key !== aulaKey && a.diaSemana === aula.diaSemana))) {
                        const aulasFiltradas = aulasAlteradas
                            .filter(a => a.key !== aulaKey && a.diaSemana === aula.diaSemana)
                            .sort((a, b) => moment(a.horaInicio, "HH:mm").diff(moment(b.horaInicio, "HH:mm")));

                        if (aulasFiltradas.length > 0) {
                            const ultimaAula = aulasFiltradas[aulasFiltradas.length - 1];

                            aulasAlteradas = calcularProximaHora(aulasAlteradas, aulaKey, ultimaAula.horaTermino);
                        }
                    }
                }
                break;
            case "diaSemana":
                {
                    const aula = aulasAlteradas.find(a => a.key === aulaKey);

                    if (!(aula?.disciplinaId && !aulasAlteradas.some(a => a.key !== aulaKey && a.diaSemana === valor))) {
                        const aulasFiltradas = aulasAlteradas
                            .filter(a => a.key !== aulaKey && a.diaSemana === valor)
                            .sort((a, b) => moment(a.horaInicio, "HH:mm").diff(moment(b.horaInicio, "HH:mm")));

                        if (aulasFiltradas.length > 0) {
                            const ultimaAula = aulasFiltradas[aulasFiltradas.length - 1];

                            aulasAlteradas = calcularProximaHora(aulasAlteradas, aulaKey, ultimaAula.horaTermino);
                        }
                    }
                }
                break;
            case "horaInicio":
                aulasAlteradas = aulasAlteradas.map(aula =>
                    aula.key === aulaKey ? { ...aula, ["horaTermino"]: moment(valor).add(1, "hour") } : aula
                );
                break;
        }

        form.resetFields();
        setAulas(aulasAlteradas);
    };

    const carregarRangeCalendario = () => {
        if (vistaCalendario === "month") {
            return {
                inicio: moment(dataCalendario).startOf("month").startOf("isoWeek").toDate(),
                fim: moment(dataCalendario).endOf("month").endOf("isoWeek").subtract(1, "day").endOf("day").toDate()
            };
        } else {
            return {
                inicio: moment(dataCalendario).startOf("isoWeek").toDate(),
                fim: moment(dataCalendario).endOf("isoWeek").subtract(1, "day").endOf("day").toDate()
            };
        }
    };

    const carregarDiasSemana = (inicio, fim) => {
        const dias = [];
        let current = moment(inicio);

        while (current <= moment(fim)) {
            dias.push({
                value: current.format("YYYY-MM-DD"),
                label: current.format("dddd")
            });

            current.add(1, "day");
        }

        return dias;
    };

    const calcularSemanasDoMes = (inicio, fim) => {
        const semanas = [];
        let atual = moment(inicio);

        while (atual.isBefore(fim)) {
            semanas.push({
                inicio: atual.toDate(),
                fim: atual.clone().endOf("day").add(5, "days").endOf("day").toDate()
            });
            atual.add(7, "days");
        }

        return semanas;
    };

    const salvarAulas = () => {
        if (repetir && !dataLimite && totalSemanas <= 0) {
            setErroRepetir(true);
            setIsLoading(false);
            return;
        }

        form.validateFieldsAndScroll(err => {
            if (!err) {
                if (repetir) {
                    salvarAulasRepetir();
                } else {
                    salvarAulasSemana();
                }
            }
        });
    };

    const salvarAulasSemana = () => {
        setIsLoading(true);

        const aulasParaEnviar = aulas.map(a => ({
            ...a,
            horaInicio: a.horaInicio.format("HH:mm"),
            horaTermino: a.horaTermino.format("HH:mm")
        }));

        axios({
            method: "post",
            url: "/api/aulas/guardar-lote",
            data: aulasParaEnviar
        })
            .then(() => {
                onSalvar();
                resetFiled();
            })
            .catch(error => {
                const problemas = error.response?.data?.problemas;

                if (problemas?.length) {
                    setProblemasPorAula(problemas);
                } else {
                    notify.error(
                        "Erro",
                        error?.response?.data?.message ||
                            error?.response?.data ||
                            error?.message ||
                            "Ocorreu um erro inesperado. Por favor, tente novamente."
                    );
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const salvarAulasRepetir = () => {
        setIsLoading(true);

        const aulasParaEnviar = aulas.map(a => ({
            ...a,
            horaInicio: a.horaInicio.format("HH:mm"),
            horaTermino: a.horaTermino.format("HH:mm")
        }));

        axios({
            method: "post",
            url: "/api/aulas/guardar-lote-repetir",
            data: {
                aulas: aulasParaEnviar,
                recorrencia: {
                    DataLimite: dataLimite,
                    NumeroSemanas: totalSemanas
                }
            }
        })
            .then(response => {
                onSalvarRepetir(response.data);
                resetFiled();
            })
            .catch(error => {
                notify.error(
                    "Erro",
                    error?.response?.data?.message ||
                        error?.response?.data ||
                        error?.message ||
                        "Ocorreu um erro inesperado. Por favor, tente novamente."
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const removerAula = aulaKey => {
        if (aulas.length === 1) return;

        setAulas(aulas.filter(aula => aula.key !== aulaKey));
    };

    const validarHoraTermino = (rule, value, callback, aulaKey) => {
        const horaInicio = form.getFieldValue(`horaInicio_${aulaKey}`);

        if (horaInicio && value && value.isBefore(horaInicio)) {
            callback("A hora de término deve ser posterior à hora de início");
        } else {
            callback();
        }
    };

    useEffect(() => {
        const range = carregarRangeCalendario();
        if (!range) return;

        const { inicio, fim } = range;
        const fmt = d => moment(d).format("DD/MM/YYYY");

        switch (vistaCalendario) {
            case "month": {
                const semanasDoMes = calcularSemanasDoMes(inicio, fim);
                const inicioPrimeiraSemana = semanasDoMes[0].inicio;
                const fimPrimeiraSemana = semanasDoMes[0].fim;

                setSemanas(semanasDoMes);
                setDiasSemana(carregarDiasSemana(inicioPrimeiraSemana, fimPrimeiraSemana));
                setSemanasSelecionada({
                    inicio: fmt(inicioPrimeiraSemana),
                    fim: fmt(fimPrimeiraSemana)
                });
                break;
            }
            case "week":
                setDiasSemana(carregarDiasSemana(inicio, fim));
                setSemanasSelecionada({ inicio: fmt(inicio), fim: fmt(fim) });
                break;
            case "day": {
                const dia = moment(dataCalendario).startOf("day").toDate();
                setDiasSemana(carregarDiasSemana(dia, dia));
                setSemanasSelecionada({ inicio: fmt(inicio), fim: fmt(fim) });
                break;
            }
            default:
                break;
        }
    }, [dataCalendario, vistaCalendario]);

    useEffect(() => {
        aulas.forEach(aula => {
            if (aula.disciplinaId && aula.diaSemana && !aula.horaInicio) {
                carregarHoraDisponivel(aula.key, aula.disciplinaId, aula.diaSemana);
            }
        });
    }, [aulas]);

    const resetFiled = () => {
        form.resetFields();

        setRepetir(false);
        setDataLimite(null);
        setTotalSemanas(0);
        setErroRepetir(false);
        setAulas([{ key: 1, disciplinaId: undefined, diaSemana: undefined, horaInicio: null, horaTermino: null, professorId: undefined }]);
        setProfessores([]);
        setProblemasPorAula([]);
        onClose();
    };

    const onCancel = () => {
        if (!isLoading) {
            resetFiled();
        }
    };

    const { getFieldDecorator } = form;

    const menu = (
        <Menu>
            {semanas.map((semana, index) => (
                <Menu.Item
                    key={index}
                    onClick={() => {
                        setDiasSemana(carregarDiasSemana(semana.inicio, semana.fim));
                        setSemanasSelecionada({
                            inicio: moment(semana.inicio).format("DD/MM/YYYY"),
                            fim: moment(semana.fim).format("DD/MM/YYYY")
                        });
                    }}
                >
                    Semana {index + 1}: {moment(semana.inicio).format("DD/MM")} - {moment(semana.fim).format("DD/MM")}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Modal
            title="Adicionar aulas ao Diário"
            visible={visible}
            onOk={() => {}}
            onCancel={onCancel}
            footer={null}
            width={600}
            className="modal-criacao-lote-aulas"
        >
            <div className="modal-criacao-lote-aulas-body">
                {vistaCalendario === "month" ? (
                    <Dropdown overlay={menu} trigger={["click"]}>
                        <div className="aula-lote-info">
                            <span>
                                Semana: {semanaSelecionada?.inicio} a {semanaSelecionada?.fim}
                            </span>
                            <Icon type="caret-down" />
                        </div>
                    </Dropdown>
                ) : (
                    <div className="aula-lote-info single">
                        Semana: {semanaSelecionada?.inicio} a {semanaSelecionada?.fim}
                    </div>
                )}
                <div className="aula-lote-repetir">
                    <Checkbox className="aula-lote-repetir-aulas" checked={repetir} onChange={e => setRepetir(e.target.checked)}>
                        Repetir estas aulas
                    </Checkbox>
                    <div className={`aula-lote-repetir-opcoes ${repetir ? "ativo" : ""}`}>
                        <div className="aula-lote-repetir-opcao">
                            <label>Até:</label>
                            <DatePicker
                                className="input-25"
                                placeholder="Selecionar"
                                format="DD-MM-YYYY"
                                name="dt_fimAula"
                                value={dataLimite}
                                onChange={handleChangeDataLimite}
                            />
                        </div>
                        <div>Ou</div>
                        <div className="aula-lote-repetir-opcao">
                            <label>Nº de semanas:</label>
                            <InputNumber value={totalSemanas} onChange={handleChangeTotalSemanas} />
                        </div>
                        {erroRepetir && !dataLimite && totalSemanas <= 0 && (
                            <span className="texto-erro">Preencha a data limite ou o número de semanas</span>
                        )}
                    </div>
                </div>
                {aulas.map((aula, index) => (
                    <div
                        key={aula.key}
                        className={`aula-lote ${problemasPorAula.some(p => p.index === index) ? "aula-lote-problemas" : ""}`}
                    >
                        <div className="aula-lote-header">
                            <h4>Aula {index + 1}</h4>
                            {aulas.length > 1 && (
                                <Button size="small" onClick={() => removerAula(aula.key)}>
                                    <Icon type="delete" />
                                </Button>
                            )}
                        </div>
                        <Form>
                            <div className="aula-lote-body">
                                <div>
                                    <Form.Item label="Disciplina">
                                        {getFieldDecorator(`disciplina_${aula.key}`, {
                                            rules: [{ required: true, message: "Selecione a disciplina" }],
                                            initialValue: aula.disciplinaId
                                        })(
                                            <Select
                                                placeholder="Selecionar"
                                                style={{ width: "100%" }}
                                                onChange={value => atualizarAula(aula.key, "disciplinaId", value)}
                                            >
                                                {disciplinas.map(disc => (
                                                    <Option key={disc.id} value={disc.id}>
                                                        {disc.nome}
                                                    </Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </div>
                                <div>
                                    <Form.Item label="Dia da Semana">
                                        {getFieldDecorator(`diaSemana_${aula.key}`, {
                                            rules: [{ required: true, message: "Selecione o dia da semana" }],
                                            initialValue: aula.diaSemana
                                        })(
                                            <Select
                                                placeholder="Selecionar"
                                                style={{ width: "100%" }}
                                                onChange={value => atualizarAula(aula.key, "diaSemana", value)}
                                            >
                                                {diasSemana.map(dia => (
                                                    <Option key={dia.value} value={dia.value}>
                                                        {dia.label}
                                                    </Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="aula-lote-body">
                                <div>
                                    <Form.Item label="Hora Início">
                                        {getFieldDecorator(`horaInicio_${aula.key}`, {
                                            rules: [{ required: true, message: "Informe a hora" }],
                                            initialValue: aula.horaInicio ? moment(aula.horaInicio, "HH:mm") : null
                                        })(
                                            <TimePicker
                                                format="HH:mm"
                                                style={{ width: "100%" }}
                                                onChange={time => atualizarAula(aula.key, "horaInicio", time)}
                                                placeholder="07:00"
                                            />
                                        )}
                                    </Form.Item>
                                </div>
                                <div>
                                    <Form.Item label="Hora Término">
                                        {getFieldDecorator(`horaTermino_${aula.key}`, {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Informe a hora"
                                                },
                                                {
                                                    validator: (rule, value, callback) =>
                                                        validarHoraTermino(rule, value, callback, aula.key)
                                                }
                                            ],
                                            initialValue: aula.horaTermino ? moment(aula.horaTermino, "HH:mm") : null
                                        })(
                                            <TimePicker
                                                format="HH:mm"
                                                style={{ width: "100%" }}
                                                onChange={time => atualizarAula(aula.key, "horaTermino", time)}
                                                placeholder="08:00"
                                            />
                                        )}
                                    </Form.Item>
                                </div>
                            </div>
                            <div>
                                <Form.Item label="Professor">
                                    {getFieldDecorator(`professorId_${aula.key}`, {
                                        initialValue: aula.professorId
                                    })(
                                        <Select
                                            placeholder="Selecionar"
                                            style={{ width: "100%" }}
                                            onChange={value => atualizarAula(aula.key, "professorId", value)}
                                        >
                                            {professores.map(prof => (
                                                <Option key={prof.id} value={prof.id}>
                                                    {prof.nome}
                                                </Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </div>
                        </Form>
                        <div className="aula-lote-problemas">
                            <ul>
                                {problemasPorAula[index]?.mensagens.map(mensagem => (
                                    <li>{mensagem}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
            <div className="modal-criacao-lote-aulas-actions">
                <Button type="secondary" onClick={adicionarAula}>
                    <Icon type="plus" /> Adicionar Aula
                </Button>
                <Button type="primary" disabled={isLoading} onClick={salvarAulas}>
                    <Icon type="save" />
                    {isLoading ? "A salvar aulas..." : `Salvar todas (${aulas.length})`}
                </Button>
            </div>
        </Modal>
    );
};

export default Form.create({ name: "form-criacao-lote-aulas" })(ModalCriacaoLoteAulas);
